import { useBreakpoints } from "@vueuse/core";

import tailwindBreakpoints from "@/utils/screens.json";

const breakpoints = useBreakpoints(tailwindBreakpoints);
export default () => {
  const isMobile = breakpoints.smaller("sm");
  const isGreaterThenMobile = breakpoints.greaterOrEqual("sm");
  const isTablet = breakpoints.between("sm", "lg");
  const isGreaterThenMedium = breakpoints.greaterOrEqual("md");
  const isDesktop = breakpoints.greaterOrEqual("lg");
  const menu = breakpoints.greaterOrEqual("menu");
  const isXl = breakpoints.greater("xl");

  const isSmallerThanDesktop = breakpoints.smaller("lg");

  return {
    isMobile,
    isTablet,
    isDesktop,
    isXl,
    menu,
    isSmallerThanDesktop,
    isGreaterThenMobile,
    isGreaterThenMedium,
  };
};
